import script from "./BackHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BackHeader.vue?vue&type=style&index=0&id=36100efe&lang=postcss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36100efe"]])

export default __exports__